import { supportServiceConnectClient } from "api";

import { ListContractorCompanySummariesRequest } from "@safetyculture/s12-apis-connect-web/s12/contractors/admin/v1/contractors_pb";
import {
  SupportListContractorCompanySummariesRequest,
  SupportListContractorCompanySummariesResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { RequestMetadata } from "api/types";
import { toUUID } from "helpers/s12-helpers";

type ListContractorCompanySummariesParams = {
  orgId: string;
  pageSize?: number;
  pageToken?: string;
};

export const listContractorCompanySummaries = async (
  { orgId, pageSize, pageToken }: ListContractorCompanySummariesParams,
  headers: Record<RequestMetadata, string>,
): Promise<SupportListContractorCompanySummariesResponse> => {
  const req = new SupportListContractorCompanySummariesRequest({
    request: new ListContractorCompanySummariesRequest({
      orgId: toUUID(orgId),
      pageSize: pageSize ?? 50,
      pageToken: pageToken ?? "",
    }),
  });

  return supportServiceConnectClient.listContractorCompanySummaries(req, {
    headers,
  });
};
